import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { PlusIcon } from '@heroicons/react/24/solid'
import ModalForm from '../../components/common/ModalForm';
import {
  FournisseurEditForm,
  FournisseurForm,
  ProduitAddForm,
  ProduitEditForm,
} from '../../config/index';
import {
  addFournisseur, deleteFournisseur, editFournisseur, getAllCategories, getAllFournisseurs

} from '../../store/settingsSlice';
import CommonForm from '../../components/common/CommonForm';
import {
  addProduit,
  editProduit,
  deleteProduit,
  getAllProduits
} from '../../store/produitSlice';



function Fournisseur() {

  const { fournisseurList, categorieList } = useSelector((state) => state.settings);
  const { produitList } = useSelector((state) => state.produit);
  const [selectedFournisseur, setSelectedFournisseur] = useState();
  const [selectedProduit, setSelectedProduit] = useState();
  const [currentEditeId, setCurrentEditeId] = useState(null);

  const [typeForm, setTypeForm] = useState("f");


  const [formControls, setFormControls] = useState(FournisseurForm);
  const [formTitle, setformTitle] = useState("Ajouter un fournisseur");

  const addCategorieField = (form) => {

    const formattedCategorieList = categorieList.map((categorie) => ({
      id: categorie.id.toString(),
      label: categorie.designation,
    }));

    const formattedFournisseurList = fournisseurList.map((categorie) => ({
      id: categorie.id.toString(),
      label: categorie.nomcompagnie,
    }));

    // Mettez à jour le formulaire avec un nouveau champ pour la catégorie
    const updatedForm = [
      ...form, // Copie des champs existants
      {
        label: "Catégorie",
        name: "categorieid",
        componentType: "select",
        options: formattedCategorieList,
      },
      {
        label: "Fournisseur",
        name: "fournisseurid",
        componentType: "select",
        options: formattedFournisseurList,
      },
    ];

    // Définissez les contrôles du formulaire
    setFormControls(updatedForm);


  };

  //console.log("fournisseurForm", FournisseurForm);

  useEffect(() => {
    dispatch(getAllFournisseurs());
    dispatch(getAllCategories());
    dispatch(getAllProduits());
    if (fournisseurList && fournisseurList.length > 0) {
      setSelectedFournisseur(fournisseurList[0]);
    }

    if (produitList && produitList.length > 0) {
      setSelectedProduit(produitList[0]);
    }

  }, [getAllFournisseurs, getAllCategories]);


  // Modal Form start here 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [mode, setMode] = useState("add");

  const dispatch = useDispatch();

  //console.log(formData, 'formdata');



  const handleSubmit = (e) => {
    e.preventDefault();

    typeForm === "f"
      ? (
        currentEditeId !== null
          ? dispatch(
            editFournisseur({
              id: currentEditeId,
              formData,
            })
          ).then((data) => {
            if (data?.payload?.success) {
              dispatch(getAllFournisseurs());
              setSelectedFournisseur(data?.payload?.data);
              setFormData({});
              setFormControls(FournisseurForm);
              setIsModalOpen(false);// Ferme le modal aprs la soumission
            }
          })
          : dispatch(
            addFournisseur(formData)).then((data) => {
              if (data?.payload?.success) {
                dispatch(getAllFournisseurs());
                setSelectedFournisseur(data?.payload?.data);
                setFormData({});
                setFormControls(FournisseurEditForm);
                setIsModalOpen(false);// Ferme le modal après la soumission
              }
            })

      )
      : (
        currentEditeId !== null
          ? dispatch(
            editProduit({
              id: currentEditeId,
              formData,
            })
          ).then((data) => {
            if (data?.payload?.success) {
              dispatch(getAllProduits());
              setSelectedProduit(data?.payload?.data);
              setFormData({});
              setFormControls(ProduitAddForm);
              setIsModalOpen(false);// Ferme le modal aprs la soumission
            }
          })
          : dispatch(
            addProduit(formData)).then((data) => {
              console.log(data);
              if (data?.payload?.success) {
                dispatch(getAllProduits());
                setSelectedProduit(data?.payload?.data);
                setFormData({});
                setFormControls(ProduitEditForm);
                setIsModalOpen(false);// Ferme le modal après la soumission
              }
            })
      )

    setTypeForm("f");
  };

  function handleDelete(id) {
    // alert avec confirmation
    if (!window.confirm("Voulez-vous vraiment supprimer la catégorie : " + selectedFournisseur?.nomcompagnie)) {
      return;
    }
    dispatch(deleteFournisseur(id)).then((data) => {
      if (data?.payload?.success) {
        dispatch(getAllFournisseurs());
        setSelectedFournisseur(data?.payload?.data);
        setFormData({});
        setIsModalOpen(false);// Ferme le modal aprs la soumission
      }
    });
  }

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermProduit, setSearchTermProduit] = useState("");
  const [filteredFournisseurs, setFilteredFournisseurs] = useState([]);
  const [filteredProduits, setFilteredProduits] = useState([]);




  useEffect(() => {

    // Fournisseur filter
    if (fournisseurList && fournisseurList.length > 0) {
      const filteredF = fournisseurList.filter((fournisseur) =>
        fournisseur.nomcompagnie.toLowerCase().includes(searchTerm.toLowerCase()));

      setSelectedFournisseur(filteredF[0]);


      setFilteredFournisseurs(filteredF);
    }

    // Produit filter
    if (produitList && produitList.length > 0) {
      const filteredP = produitList.filter((product) =>
        product.designation.toLowerCase().includes(searchTermProduit.toLowerCase()));

      setSelectedProduit(filteredP[0]);

      setFilteredProduits(filteredP);
    }

  }, [fournisseurList, searchTerm, produitList, searchTermProduit]);


  const handleSearFchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleSearPchChange = (e) => {
    setSearchTermProduit(e.target.value);
  };


  function handleModal(formFourni) {

    switch (formFourni) {
      case 'fournisseur':
        console.log(typeForm);
        setFormControls(FournisseurForm);
        setformTitle("Ajouter un fournisseur");
        break;

      case 'produit':
        console.log(typeForm);
        addCategorieField(ProduitAddForm);
        setformTitle("Ajouter un produit");
        break;

      case 'FournisseurEditForm':
        console.log(typeForm);
        setFormControls(FournisseurEditForm);
        setformTitle("Modifier un fournisseur");
        break;

      default:
        // Si aucun formulaire spécifique n'est spécifié, utilisez le formulaire fournisseur par défaut
        console.log(typeForm);
        setFormControls(FournisseurForm);
        setformTitle("Ajouter un fournisseur");
        break;
    }

    setIsModalOpen(true); // Ouvre le modal

  }

  const [activeTab, setActiveTab] = useState(0);
  const tabs = ["Details", "Produits"];

  return (
    <div className="flex sm:flex-row md:flex-col flex-1 gap-4 bg-gray-100 md:mt-16 p-6">
      {/* Sidebar */}
      <div className="col-span-1 bg-white p-6 border rounded">
        <div className="grid grid-cols-8 mb-2 px-3 border-b">
          <PlusIcon
            onClick={() => {
              setTypeForm("f");
              handleModal('fournisseur');
            }}
            title='Ajouter un fournisseur'
            className="col-span-1 pt-3 w-9 h-9 text-teal-400 cursor-pointer" />
          <form action="" className="flex col-span-7">
            <input
              className="flex-1 p-3 focus:outline-none"
              type="text"
              placeholder="Recherche..."
              value={searchTerm}
              onChange={handleSearFchChange}
            />
          </form>
        </div>

        <div>
          <h2 className="mb-4 font-bold text-lg">Fournisseurs</h2>
          {/* item */}
          <ul className="space-y-2 min-h-[610px] max-h-[610px] overflow-y-scroll">
            {filteredFournisseurs.map((fournisseur) => (
              <li className={`
              flex flex-row items-center hover:bg-teal-500 active:bg-teal-500 px-3 py-2
               text-gray-600 text-left text-sm hover:text-white duration-800 cursor-pointer
               ${fournisseur.id === selectedFournisseur?.id ? "bg-teal-500 text-white" : ""}
               `} key={fournisseur.id}

                onClick={() => {
                  setSelectedFournisseur(fournisseur)
                }}
              >
                {fournisseur.nomcompagnie}

              </li>
            ))}
          </ul>

          {/* end item */}
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col flex-1 bg-white p-6 border rounded">
        <div className="flex flex-col flex-1">
          <div className="relative w-full">
            {/* Tabs Header */}
            <div className="relative flex justify-center space-x-4">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTab(index)}
                  className={`py-2 px-4 text-gray-500 hover:text-blue-500 transition ${activeTab === index ? "text-blue-500 border-b-2 border-blue-500" : ""
                    }`}
                >
                  {tab}
                </button>
              ))}
            </div>
            {/* Tabs Content */}
            <div className="p-4">
              {activeTab === 0 &&
                <div>

                  {/* Détails de la catégorie */}
                  {selectedFournisseur ? (
                    <div className="flex-1 p-6 min-h-[540px] max-h-[540px] overflow-y-scroll">
                      <div className="flex justify-between items-center mb-4">
                        <h1 className="font-bold text-2xl">{selectedFournisseur.nomcompagnie}</h1>
                        <span
                          className={`text-sm font-medium px-3 py-1 rounded ${selectedFournisseur.disable ? "bg-red-500 text-white" : "bg-green-500 text-white"
                            }`}
                        >
                          {selectedFournisseur.disable ? "Inactive" : "Active"}
                        </span>
                      </div>
                      <div className="space-y-4 text-gray-600">
                        <p>
                          <strong>Téléphone : </strong>
                          {selectedFournisseur.telephone}
                        </p>
                        <p>
                          <strong>Email : </strong>
                          {selectedFournisseur.email}
                        </p>
                        <p>
                          <strong>Adresse : </strong>
                          {selectedFournisseur.adresse}, {selectedFournisseur.ville}, {selectedFournisseur.pays}
                        </p>
                        {selectedFournisseur.notes && selectedFournisseur.notes.split("\n").map((paragraph, index) => (
                          <p key={index}>{paragraph}</p>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="flex-1 p-6 min-h-[500px] max-h-[500px] overflow-y-scroll">
                      <p>Chargement des données...</p>
                    </div>
                  )}
                  {/* Footer avec le bouton Modifier */}
                  <footer className="flex justify-between items-center p-4 border-t">
                    <button
                      onClick={() => {
                        handleDelete(selectedFournisseur.id);
                      }}
                      className="bg-red-500 hover:bg-red-600 px-4 py-2 rounded text-white transition"
                    >
                      Supprimer
                    </button>

                    <button
                      onClick={() => {
                        setCurrentEditeId(selectedFournisseur.id);
                        handleModal('FournisseurEditForm');
                        setFormData(selectedFournisseur);
                        setMode("view");
                        setformTitle("Modifier le fournisseur");
                      }}
                      className="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded text-white transition"
                    >
                      Modifier
                    </button>
                  </footer>

                </div>}
              {activeTab === 1 &&
                <div>

                  {/* start Produits */}
                  <div className="grid grid-cols-8 mb-2 px-3 border-b">
                    <PlusIcon
                      onClick={() => {
                        setTypeForm("p")
                        handleModal('produit');
                      }}
                      title='Ajouter un produit'
                      className="col-span-1 pt-3 w-9 h-9 text-teal-400 cursor-pointer" />
                    <form action="" className="flex col-span-7">
                      <input
                        className="flex-1 p-3 focus:outline-none"
                        type="text"
                        placeholder="Recherche..."
                        value={searchTermProduit}
                        onChange={handleSearPchChange}
                      />
                    </form>
                  </div>


                  {/* start Fournisseurs */}
                  <table className="table-fixed w-full">

                    {/* table head */}
                    <thead className="text-left">
                      <tr className=''>
                        <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Produit</th>
                        <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Description</th>
                        <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Prix KMF</th>
                        <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Qt Stock</th>
                        <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Stock Min</th>
                      </tr>
                    </thead>
                    {/* end table head */}

                    {/* table body */}
                    <tbody className="text-gray-600 text-sm">
                      {filteredProduits.map((produit) => (
                        <tr
                          className="hover:bg-teal-500 hover:text-white hover:cursor-pointer"

                          key={produit.id}

                          onClick={() => {
                            setSelectedProduit(produit)
                          }}
                        >

                          {/* name */}
                          <td className="border-1 px-2 py-1 border">
                            {produit.designation}
                          </td>
                          {/* name */}

                          {/* product */}
                          <td className="px-2 py-1 border border-l-0">
                            {produit.unite}
                          </td>
                          {/* product */}

                          {/* invoice */}
                          <td className="px-2 py-1 border border-l-0">{produit.prix} </td>
                          {/* invoice */}

                          {/* price */}
                          <td className="px-2 py-1 border border-l-0">{produit.stockqty}</td>
                          {/* price */}

                          {/* status */}
                          <td className="px-2 py-1 border border-l-0">{produit.alertstockqty}</td>
                          {/* status */}

                        </tr>

                      ))}

                    </tbody>
                    {/* end table body */}

                  </table>
                  {/* end Fournisseur */}

                </div>}
            </div>
          </div>
        </div>
        <div className="flex justify-between card-footer">
          <p>4.41 GB (25%) of 17 GB used Manage</p>
          <p>Last account activity: 36 minutes ago</p>
        </div>
      </div>
      <ModalForm
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        children={
          <CommonForm
            formTitle={formTitle}
            formControls={formControls}
            formData={formData}
            mode={mode}
            setFormData={setFormData}
            handleSubmit={handleSubmit}
            isBtnDisabled={isBtnDisabled}
          />
        }
      />
    </div>
  )
}

export default Fournisseur